<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>Republish Entity from Current Base</h3>
    </div>

    <div class="box">
      @if (loading) {
        <div class="loading-container">
          <importer-app-loading-screen
            [local]="true"
            [contrast]="true"></importer-app-loading-screen>
        </div>
      }
      @if (!loading) {
        <div class="group">
          <div class="flex-container">
            @if (entities.length) {
              <importer-dropdown
                label="File Type"
                [items]="entities"
                [shadow]="true"
                [displayFn]="dropdownDisplayFn"
                [disabled]="publishing"
                [disableOptionFn]="disableOption"
                [disableCommentFn]="disableComment"
                (selectionChange)="applySelectionChange($event)"></importer-dropdown>
            }
          </div>
          @if (selectedFileTypePrefix) {
            <div
              class="flex-container"
              style="justify-content: flex-start; flex: 0 1 35%">
              <coin-v2-checkbox
                [ngModel]="fullBaseActive"
                (ngModelChange)="onToggle($event)"></coin-v2-checkbox>
              <p><strong>Full Base</strong></p>
            </div>
          }
          @if (selectedFileTypePrefix) {
            <div class="flex-container">
              @for (key of selectedFileTypeKeys; track key) {
                <coin-v2-text-input
                  [label]="key"
                  [disabled]="fullBaseActive"
                  [(ngModel)]="objectIdentifiers[key]"></coin-v2-text-input>
              }
            </div>
          }
        </div>
      }
      <div class="buttons">
        <coin-v2-button
          [type]="'secondary'"
          [icon]="'close'"
          [iconPos]="'right'"
          [text]="publishing ? 'Cancel' : 'Close'"
          (click)="close()"></coin-v2-button>

        <coin-v2-button
          [type]="'primary'"
          [icon]="'upload'"
          [iconPos]="'right'"
          [text]="publishing ? 'Publishing' : 'Publish'"
          [disabled]="!selectedFileTypeKeys || !isValid() || publishing"
          (click)="save()"></coin-v2-button>
      </div>
    </div>
  </div>
</div>
